import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EventEmitter from '../../../utils/eventEmitter';
import useProductPackagingAPI from '../../apis/productPackagingAPI';



const ProductPackagingChanges = () => {
  const {products, routes, packageTypes, productPackage} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState(productPackage.name ? productPackage.name : '');
  const { create, update } = useProductPackagingAPI();
  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(productPackage.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };


  useEffect(() => {
    EventEmitter.subscribe('product_packaging_created', data => {
      navigate('/inventory/packaging/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('product_packaging_created');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/packaging'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Product Packaging</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ productPackage.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {productPackage.seo && <Button onClick={edit}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='routechanges'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Packaging Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={productPackage.seo ? productPackage : {
            sales: false,
            purchase: false
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              <Form.Item label='Product' name='product_id' className='font-semibold text-gray-800 mb-4' required >
                <Select options={products.map(product => ({value: product.id, label: product.name}))}/>
              </Form.Item>
              <Form.Item label='Sales' name={'sales'} valuePropName='checked' className='font-semibold text-gray-800 mb-4' required>
                <Checkbox />
              </Form.Item>
              <Form.Item label='Purchase' name={'purchase'} valuePropName='checked' className='font-semibold text-gray-800 mb-4' required>
                <Checkbox />
              </Form.Item>
              <Form.Item label='Routes' name={'routes'} className='font-semibold text-gray-800 mb-4' required>
                <Select options={routes.map(route => ({value: route.id, label: route.name}))}/>  
              </Form.Item>
            </Col>
            <Col md={{ span: 10, offset: 1 }}>
              <Form.Item labelCol={{span: 10}} label='Package Type' name={'package_type'} className='font-semibold text-gray-800 mb-4' required>
                <Select options={packageTypes.map(packageType => ({value: packageType.id, label: packageType.name}))}/>  
              </Form.Item>
              <Form.Item labelCol={{span: 10}} label='Contained Quantity' name={'contained_quantity'} className='font-semibold text-gray-800 mb-4' required>
                <InputNumber className='w-full'/>  
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default ProductPackagingChanges;